import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Failed Stroke
 */

export default function FailedStrokeIcon(props) {
  return (
    <Icon viewBox="0 0 48 48" {...props}>
      <path
        clipRule="evenodd"
        d="M45 24C45 35.598 35.598 45 24 45C12.402 45 3 35.598 3 24C3 12.402 12.402 3 24 3C35.598 3 45 12.402 45 24ZM48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM32.4728 15.5272C33.1757 16.2302 33.1757 17.3698 32.4728 18.0728L26.5456 24L32.4728 29.9272C33.1757 30.6302 33.1757 31.7698 32.4728 32.4728C31.7698 33.1757 30.6301 33.1757 29.9272 32.4728L24 26.5456L18.0728 32.4728C17.3698 33.1757 16.2302 33.1757 15.5272 32.4728C14.8243 31.7698 14.8243 30.6301 15.5272 29.9272L21.4544 24L15.5272 18.0728C14.8243 17.3699 14.8243 16.2302 15.5272 15.5272C16.2302 14.8243 17.3698 14.8243 18.0728 15.5272L24 21.4544L29.9272 15.5272C30.6302 14.8243 31.7698 14.8243 32.4728 15.5272Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
